import { Injectable } from '@angular/core';
import { AppConsts } from '@shared/AppConsts';
import { TokenAuthServiceProxy } from '@shared/service-proxies/service-proxies';
import {AppSessionService} from '@shared/session/app-session.service';
import LogRocket from 'logrocket';

@Injectable()
export class AppAuthService {
    public constructor(
      private _authServiceProxy: TokenAuthServiceProxy,
      private _appSessionService: AppSessionService) {
      if (this._appSessionService.userId != null) {
        LogRocket.identify(this._appSessionService.userId.toString(), {
          name: `${this._appSessionService.user.name} ${this._appSessionService.user.surname}`,
          email: this._appSessionService.user.emailAddress
        });
      }
    }

    public logout(reload?: boolean): void {
        // call the api and then clear tokens here
        this._authServiceProxy.logout()
          .subscribe(() => {
            abp.auth.clearToken();
            abp.utils.setCookieValue(AppConsts.authorization.encryptedAuthTokenName, undefined, undefined, abp.appPath);
            if (reload !== false) {
              location.href = AppConsts.appBaseUrl;
            }
        });

    }
}
